import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config/api';

const Home = () => {
  useEffect(() => {
    // Track page view
    axios.post(`${API_URL}/api/track`, { page: 'home', action: 'page_view' }).catch(() => {});
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section
        className="relative h-[72vh] sm:h-[82vh] md:h-[86vh] lg:h-[92vh] w-full bg-cover bg-no-repeat bg-[position:68%_center] sm:bg-[position:62%_center] md:bg-center lg:bg-center"
        style={{ backgroundImage: 'url(/Homepage-2.jpeg)' }}
      >
        <div className="absolute inset-0 bg-black/5"></div>
        <div className="relative z-10 w-full h-full px-3 sm:px-6 lg:px-8 flex items-start pt-14 sm:pt-20 lg:pt-20">
          <div className="max-w-[18rem] sm:max-w-md text-[#1f3a27]">
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-semibold leading-tight mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              Pure Spices.
              <br />
              Global Trust.
            </h1>
            <div className="flex items-center gap-3 mb-4 text-[#f4c542]">
              <span className="h-px w-20 bg-[#ffd76a] shadow-[0_0_8px_rgba(244,197,66,0.85)]"></span>
              <span className="text-xl font-bold drop-shadow-[0_0_6px_rgba(244,197,66,0.95)]">✦</span>
              <span className="h-px w-20 bg-[#ffd76a] shadow-[0_0_8px_rgba(244,197,66,0.85)]"></span>
            </div>
            <p className="text-base sm:text-lg leading-relaxed mb-6 text-[#1f2b1f]">
              Premium quality spices, carefully sourced and processed to deliver purity, flavor,
              and goodness in every pack.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-3">
            <Link
              to="/products"
              className="inline-flex items-center justify-center bg-[#1f3a27] text-white px-6 sm:px-8 py-3 rounded-full text-sm sm:text-base font-semibold tracking-wide uppercase hover:bg-[#17301f] transition-colors"
            >
              Explore Our Products <span className="ml-2">→</span>
            </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-[#fdfaf2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#1f3a27]" style={{ fontFamily: 'Georgia, serif' }}>Why Choose Earthly Spice Exports?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center bg-[#fffdf8] border border-[#e7decb] rounded-2xl p-6 shadow-sm">
              <div className="text-5xl mb-4">🌿</div>
              <h3 className="text-xl font-bold mb-3">100% Pure Spices</h3>
              <p className="text-gray-600">
                Our spices are carefully selected and processed with no fillers or preservatives, 
                ensuring you get the purest and healthiest spices.
              </p>
            </div>
            <div className="text-center bg-[#fffdf8] border border-[#e7decb] rounded-2xl p-6 shadow-sm">
              <div className="text-5xl mb-4">🏭</div>
              <h3 className="text-xl font-bold mb-3">Directly Sourced</h3>
              <p className="text-gray-600">
                All our spices are directly sourced and processed in Bangalore, 
                ensuring freshness and quality from farm to your kitchen.
              </p>
            </div>
            <div className="text-center bg-[#fffdf8] border border-[#e7decb] rounded-2xl p-6 shadow-sm">
              <div className="text-5xl mb-4">⭐</div>
              <h3 className="text-xl font-bold mb-3">Premium Quality</h3>
              <p className="text-gray-600">
                We maintain the highest standards in processing and packaging, 
                bringing you Michelin-star quality spices for your home kitchen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="py-16 bg-[#f8f3e8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#1f3a27]" style={{ fontFamily: 'Georgia, serif' }}>Spices for Cooking and Other Uses</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-center">
            <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-xl font-bold mb-2">Whole Spices</h3>
              <p className="text-gray-600 mb-4">Premium whole spices including cardamom, cinnamon, cloves, and more.</p>
            </div>
            <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-xl font-bold mb-2">Ground Spices</h3>
              <p className="text-gray-600 mb-4">Ginger Powder, Garlic Powder, Onion Powder and other ground spices.</p>
            </div>
            <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-xl font-bold mb-2">Spice Blends</h3>
              <p className="text-gray-600 mb-4">Expertly crafted blended spice mixes for various cuisines.</p>
            </div>
            <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-xl font-bold mb-2">Food Seasonings</h3>
              <p className="text-gray-600 mb-4">Perfect seasoning blends to enhance your dishes.</p>
            </div>
            <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-xl font-bold mb-2">Herbal Condiments</h3>
              <p className="text-gray-600 mb-4">Natural and herbal condiments for healthy cooking.</p>
            </div>
          </div>
          <div className="mt-12">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#1f3a27]" style={{ fontFamily: 'Georgia, serif' }}>Key Features</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-center">
              <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-600 font-semibold">Strong natural aroma</p>
              </div>
              <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-600 font-semibold">High purity &amp; quality</p>
              </div>
              <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-600 font-semibold">Hygienically processed</p>
              </div>
              <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-600 font-semibold">Export-grade packaging</p>
              </div>
              <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e7decb] shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-600 font-semibold">Bulk supply capability</p>
              </div>
            </div>
          </div>
          <div className="text-center mt-8">
            <Link
              to="/products"
              className="inline-block bg-[#1f3a27] text-white px-8 py-3 rounded-full text-sm sm:text-base font-semibold tracking-wide uppercase hover:bg-[#17301f] transition-colors"
            >
              View All Products
            </Link>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Get Started?</h2>
          <p className="text-xl mb-8 opacity-90">
            Contact us today to place your order or learn more about our products.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-primary px-8 py-3 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              Get in Touch
            </Link>
            <a
              href="https://wa.me/919902043782"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-green-700 transition-colors"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
